import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#144466'
    },
    type: 'light'
  },
  typography: {
    useNextVariants: true,
    fontFamily: 'Raleway, Avenir, Helvetica, arial',
  },
  overrides: {
    MuiPaper: {
      root: {
         backgroundColor: 'rgb(223, 236, 241)',
        '& .link-small': {
          margin: 5,
          textAlign: 'center',
          display: 'block',
          color: '#666565',
          fontSize: '0.8rem',
          '&:hover': {
            textDecoration: 'underline'
          },
        }
      }
    },
    MuiCardContent: {
      root: {
        maxWidth: 1000,
        margin: '0 auto',
        width: '100%',
      }
    },
    MuiFormControl: {
      root: {
        marginBottom: '10px'
      }
    },
    MuiButton: {
      root: {
        marginBottom: '10px',
        '&+$root': {
          marginLeft: '10px'
        }
      }
    }
  }
})